import { Select as WdsSelect, SelectProps as WdsSelectProps } from "@datamole/wds-component-select";
import { forwardRef, type ForwardedRef, type ReactNode } from "react";

type SelectProps<T> = Omit<WdsSelectProps, "children"> & {
    options: T[];
    getOptionLabel: (option: T) => ReactNode;
    getOptionValue: (option: T) => string;
    id?: string;
    placeholder?: ReactNode;
    triggerClassName?: string;
    contentClassName?: string;
    itemClassName?: string;
};

const Select = <T,>(props: SelectProps<T>, ref: ForwardedRef<HTMLButtonElement>) => {
    const {
        options,
        id,
        value,
        getOptionLabel,
        getOptionValue,
        placeholder,
        triggerClassName,
        contentClassName,
        itemClassName,
        ...rest
    } = props;

    return (
        <WdsSelect {...rest} value={value}>
            <WdsSelect.Trigger id={id} placeholder={placeholder} ref={ref} className={triggerClassName} />
            <WdsSelect.Content className={contentClassName}>
                {options.map((option) => {
                    const optionValue = getOptionValue(option);
                    const label = getOptionLabel(option);
                    return (
                        <WdsSelect.Item key={optionValue} value={optionValue} className={itemClassName}>
                            {label}
                        </WdsSelect.Item>
                    );
                })}
            </WdsSelect.Content>
        </WdsSelect>
    );
};

Select.displayName = "Select";

const SelectWithRef = forwardRef(Select) as <T>(
    props: SelectProps<T> & { ref?: ForwardedRef<HTMLButtonElement> },
) => ReturnType<typeof Select>;

export { SelectWithRef as Select };
export type { SelectProps };
